import { tsValidateMustExist, tsValidateValue } from '@nu-art/ts-common';
import { AllOperands } from './consts.js';
import { knowledgeManagerDBGroup } from '../../_entity/common.js';
const Validator_Expression = {
    op: tsValidateValue(AllOperands),
    params: tsValidateMustExist
};
export const DBDef_ExpressionsOld = {
    validator: Validator_Expression,
    dbKey: 'expressions',
    dbGroup: knowledgeManagerDBGroup,
    entityName: 'expression',
    versions: ['1.0.0'],
};
//# sourceMappingURL=db-def.js.map